export default [
    {
        path: '/bussiness-configuration',
        component: resolve => require(['../../views/settings/bussinessConfiguration/index.vue'], resolve),
        meta: { title: '业务配置' }
    },
    {
        path: '/bussiness-configuration-wechatPay',
        component: resolve => require(['../../views/settings/bussinessConfiguration/componements/weChatPay.vue'], resolve),
        meta: { title: '支付配置' }
    },
    {
        path: '/bussiness-configuration-insurance',
        component: resolve => require(['../../views/settings/bussinessConfiguration/componements/insurance.vue'], resolve),
        meta: { title: '保险配置' }
    },
    {
        path: '/bussiness-configuration-contract',
        component: resolve => require(['../../views/settings/bussinessConfiguration/componements/contract.vue'], resolve),
        meta: { title: '合同配置' }
    },
    {
        path: '/product-setting',
        component: resolve => require(['../../views/settings/storeGlobalSettings/productSetting.vue'], resolve),
        meta: { title: '产品设置' }
    },
    {
        path: '/decoration-setting',
        component: resolve => require(['../../views/settings/storeGlobalSettings/decorationSetting.vue'], resolve),
        meta: { title: '装修设置' }
    },
    {
        path: '/internal-settlement',
        component: resolve => require(['../../views/settings/settlementSettings/internalSettlement.vue'], resolve),
        meta: { title: '内部结算' }
    },
    {
        path: '/unconventional-order-setting',
        component: resolve => require(['../../views/settings/settlementSettings/unconventionalOrderSetting.vue'], resolve),
        meta: { title: '非常规订单设置' }
    },
    {
        path: '/withdrawal-function-setting',
        component: resolve => require(['../../views/settings/settlementSettings/withdrawalFunctionSetting.vue'], resolve),
        meta: { title: '提现功能设置' }
    },
    {
        path: '/account-adjustment-process-setting',
        component: resolve => require(['../../views/settings/settlementSettings/accountAdjustmentProcessSetting.vue'], resolve),
        meta: { title: '调账流程设置' }
    },
    {
        path: '/wx-pay-commission-setting',
        component: resolve => require(['../../views/settings/wxPayCommissionSetting.vue'], resolve),
        meta: { title: '微信支付手续费设置' }
    },
    {
        path: '/settings/settlementSettings/rewardFundWithdrawalSetting',
        component: resolve => require(['../../views/settings/settlementSettings/rewardFundWithdrawalSetting.vue'], resolve),
        meta: { title: '奖励基金提现设置' }
    },
    
    {
        path: '/settings/settlementSettings/paymentProportion',
        component: resolve => require(['../../views/settings/settlementSettings/paymentProportion.vue'], resolve),
        meta: { title: '支付比例' }
    },
    {
        path: '/secondary-settlement-price-setting',
        component: resolve => require(['../../views/settings/operationSettings/secondarySettlementPriceSetting.vue'], resolve),
        meta: { title: '二级结算价设置' }
    },
    {
        path: '/insurance-gifts-setting',
        component: resolve => require(['../../views/settings/operationSettings/insuranceAndGiftsSetting.vue'], resolve),
        meta: { title: '保险&赠送项目设置' }
    },
    {
        path: '/contracts-processes-setting',
        component: resolve => require(['../../views/settings/operationSettings/contractsAndProcessesSetting.vue'], resolve),
        meta: { title: '合同&流程设置' }
    },
    {
        path: '/administratorRootSettings',
        component: resolve => require(['../../views/settings/administratorSettingsCenter/administratorRootSettings.vue'], resolve),
        meta: { title: '新增管理员权限设置' }
    },
    
    
]



// WEBPACK FOOTER //
// ./src/TASMini/router/modules/settings.js